import { EMPTY_OBJECT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { ICON_HEIGHT_20 } from '../../Icon'
import { AIButton } from '../AIButton'

import * as styles from './AIButtonContainedDark.module.css'

function AIButtonContainedDark({
  beforeIconProps: {
    height: beforeIconHeight = ICON_HEIGHT_20,
    ...beforeIconProps
  } = EMPTY_OBJECT,
  className = styles.aiButtonContainedDark,
  height = BUTTON_HEIGHT_32,
  text,
  ...restProps
}) {
  return (
    <AIButton
      {...restProps}
      Button={Button.Contained}
      beforeIconProps={{ ...beforeIconProps, height: beforeIconHeight }}
      className={className}
      height={height}
      text={text}
    />
  )
}

export default AIButtonContainedDark
